import DataGrid, { Column, Grouping, GroupPanel, Pager, Paging, SearchPanel } from 'devextreme-react/data-grid';
import { AOPSelector, getAOP, getAOPTotal } from '../../store/reducers/Report/AOP'
import { useSelector, useDispatch } from 'react-redux'
import 'devextreme/dist/css/dx.light.css';
import { useEffect, useState } from "react";
import { Spin } from 'antd';
import RateCell from '../../components/shared-components/DevExpressGrid/rateCell';
import moment from 'moment';
import { Select, DatePicker, Space } from 'antd';
import { TimeDataSelCompareCompanySales } from '../data/data'

const pageSizes = [10, 20, 50, 100, 500];
const { Option } = Select;

function AOP() {
    const dispatch = useDispatch()
    const AOPSelectors = useSelector(AOPSelector)
    const [loadData, setLoadData] = useState({ FrDate: moment().startOf('month').format('yyyy/MM/DD'), ToDate: moment().endOf('month').format('yyyy/MM/DD'), TypeReport: "detail", TimeType: "", Condition: "" })
    const [loadDataTotal, setLoadDataTotal] = useState({ FrDate: moment().startOf('month').format('yyyy/MM/DD'), ToDate: moment().endOf('month').format('yyyy/MM/DD'), TypeReport: "Total", TimeType: "", Condition: "" })
    useEffect(() => {
        dispatch(getAOP(loadData))
        dispatch(getAOPTotal(loadDataTotal))
    }, [])

    useEffect(() => {
        dispatch(getAOP(loadData))
    }, [loadData])

    useEffect(() => {
        dispatch(getAOPTotal(loadDataTotal))
    }, [loadDataTotal])
    const dateChange = (date, datestring) => {
        if (date) {
            const startDate = moment(date).startOf('month').format('yyyy/MM/DD')
            const endDate = moment(date).endOf('month').format('yyyy/MM/DD')
            setLoadData({ ...loadData, FrDate: startDate, ToDate: endDate })
            setLoadDataTotal({ ...loadDataTotal, FrDate: startDate, ToDate: endDate })
        }
    }
    return (
        <>
            <Space style={{marginBottom: '16px'}}>
                <Select defaultValue={"month"} style={{ width: 250 }} disabled>
                    {TimeDataSelCompareCompanySales.map((TimeDataSel, index) => (
                        <Option key={index} value={TimeDataSel.val}>{TimeDataSel.displayvalue}</Option>
                    ))}
                </Select>
                <DatePicker onChange={dateChange} picker="month" defaultValue={moment(loadData.FrDate, 'YYYY/MM')} />
            </Space>
            <Spin tip="Loading..." spinning={AOPSelectors.Loading}>
                <div className="dx-viewport" style={{backgroundColor: 'white', padding: '10px'}}>
                    <DataGrid 
                        style={{marginBottom: '10px'}}
                        dataSource={AOPSelectors.allPageLoad}
                        allowColumnReordering={true}
                        rowAlternationEnabled={true}
                        showBorders={true}
                        columnAutoWidth={true}>
                        <GroupPanel visible={false} />
                        <SearchPanel visible={true} highlightCaseSensitive={true} width={200}/>
                        <Grouping autoExpandAll={false} />
                        <Column dataField="STT" caption={"STT"} dataType="string" width={50}/>
                        <Column dataField="SlpName" caption={"Tên nhân viên"} dataType="string" />
                        <Column dataField="U_AOP" caption={"AOP/Kg"} dataType="number" format={"#,###,###"} />
                        <Column dataField="InvQty" caption={"SL Bán (Kg)"} dataType="number" format={"#,###,###.####"} />
                        <Column dataField="DocTotal" caption={"Tổng DS (VND)"} dataType="number" format={"#,###,###"} />
                        
                        <Column
                            dataField="rateAOP"
                            caption="Tỷ lệ đặt target"
                            dataType="number"
                            format="percent"
                            alignment="right"
                            allowGrouping={false}
                            cellRender={RateCell}
                            width={250}
                        />
                        <Column dataField="rateAOP" caption={"%"} dataType="number" format={"#,###,###.##"} width={50}/>
                        <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
                        <Paging defaultPageSize={20} />
                    </DataGrid>

                    <DataGrid dataSource={AOPSelectors.AOPTotal}
                        allowColumnReordering={true}
                        rowAlternationEnabled={true}
                        showBorders={true}
                        columnAutoWidth={true}>
                        <GroupPanel visible={false} />
                        <SearchPanel visible={true} highlightCaseSensitive={true} width={200} />
                        <Grouping autoExpandAll={false} />
                        <Column dataField="Dscription" caption={"Nội dung"} dataType="string" width={100}/>
                        <Column dataField="AOP" caption={"AOP/Kg"} dataType="number" format={"#,###,###"}  width={100}/>
                        <Column dataField="InvQty" caption={"Sản lượng"} dataType="number" format={"#,###,###.####"}  />
                        <Column dataField="DocTotal" caption={"Tổng DS (VND)"} dataType="number" format={"#,###,###"}  />
                        
                        <Column
                            dataField="RateAOP"
                            caption="Tỷ lệ đặt target"
                            dataType="number"
                            format="percent"
                            alignment="right"
                            allowGrouping={false}
                            cellRender={RateCell}
                            width={250}
                        />
                        <Column dataField="RateAOP" caption={"%"} dataType="number" format={"#,###,###.##"} width={50}/>
                        <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
                        <Paging defaultPageSize={20} />
                    </DataGrid>
                </div>
            </Spin>
        </>
    );
}

export default AOP;